module.exports = "//d274d294w9cx2v.cloudfront.net/94837c638bb8453f58e190c81761206abd683878/images/photo-couple.png";